export const CONTENT_TYPES = {
  scenario: "scenario",
  trainer: "trainer",
  knowledge_base: "knowledge_base",
};

export function resolveGameContentType(game, options = {}) {
  if (!game) return CONTENT_TYPES.scenario;

  const { trainerHint = false, kbHint = false } = options;

  if (game.contentType === CONTENT_TYPES.knowledge_base) {
    return CONTENT_TYPES.knowledge_base;
  }
  if (game.settings?.contentType === CONTENT_TYPES.knowledge_base) {
    return CONTENT_TYPES.knowledge_base;
  }
  if (game.kbTheme) return CONTENT_TYPES.knowledge_base;
  if (Array.isArray(game.kbItems) && game.kbItems.length > 0) {
    return CONTENT_TYPES.knowledge_base;
  }
  if (kbHint) return CONTENT_TYPES.knowledge_base;

  if (game.contentType === CONTENT_TYPES.trainer) return CONTENT_TYPES.trainer;
  if (game.settings?.contentType === CONTENT_TYPES.trainer) {
    return CONTENT_TYPES.trainer;
  }
  if (game.trainerTheme) return CONTENT_TYPES.trainer;
  if (Array.isArray(game.trainerQuestions) && game.trainerQuestions.length > 0) {
    return CONTENT_TYPES.trainer;
  }
  if (trainerHint) return CONTENT_TYPES.trainer;

  return game.contentType || game.settings?.contentType || CONTENT_TYPES.scenario;
}

export function isTrainerGame(game, options = {}) {
  return resolveGameContentType(game, options) === CONTENT_TYPES.trainer;
}

export function isKnowledgeBaseGame(game, options = {}) {
  return resolveGameContentType(game, options) === CONTENT_TYPES.knowledge_base;
}

export function getContentTypeLabel(contentType) {
  if (contentType === CONTENT_TYPES.trainer) return "Тренажёр";
  if (contentType === CONTENT_TYPES.knowledge_base) return "База знаний";
  return "Сценарий";
}

export function getMaxButtonsForGame(game) {
  return isTrainerGame(game) ? 4 : 2;
}
